<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <sui-container>
        <h2 class="ui header">
          <i class="window maximize grey icon" />
          <sui-header-content>New service</sui-header-content>
        </h2>
        <br>
        <div class="roles" v-show="!entity">
          <div class="role" v-for="(types, groupTitle) in typesByGroup" :key="groupTitle">
            <h4 class="ui header">{{groupTitle}} services</h4>
            <sui-card-group class="types" :class="{doubling: types.length > 5}" :itemsPerRow="types.length">
              <sui-card class="type" :class="{link: !type.soon}" v-for="type in types" :key="type.typeName" @click="selectType(type)">
                <div class="type-logo">
                  <Logo class="logo" :serviceType="type.typeName" />
                </div>
                <div class="type-title">
                  {{type.typeTitle}}
                </div>
                <sui-dimmer inverted :active="type.soon">
                  <i class="lock icon" />
                  not available
                </sui-dimmer>
              </sui-card>
            </sui-card-group>
          </div>
        </div>
        <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
          <FormService v-model="entity" mode="creating" />
          <sui-message error>
            {{apiErrors}}
          </sui-message>
        </sui-form>
      </sui-container>
      <div class="actions" :class="{selected: entity}">
        <sui-container>
          <div class="ui buttons">
            <sui-button class="back" icon="arrow circle left" label-position="left" @click="reset()">Back</sui-button>
            <sui-button icon="check" label-position="right" color="green" :disabled="loading || hasEntityErrors" @click="submit()" data-goal="CREATE_SERVICE_TRY">Confirm</sui-button>
          </div>
        </sui-container>
      </div>
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import groupBy from 'lodash/groupBy'
  import pick from 'lodash/pick'
  import set from 'lodash/set'
  import objects from '@/objects'
  import utils from '@/utils'
  import FormService from '@/components/forms/Service'
  import PageForm from '@/mixins/PageForm'

  export default {
    name: 'NewServiceView',
    mixins: [
      PageForm,
    ],
    components: {
      FormService,
    },
    computed: {
      ...mapGetters(['projects']),
      queryParams() {
        const queryParams = {}
        const props = pick(this.$route.query, ['configuration', 'image', 'name', 'project', 'type', 'version'])
        for (const prop in props) {
          set(queryParams, prop, this.$route.query[prop])
        }
        const project = this.projects.find(entity => entity.id === this.$route.query.project || entity.name === this.$route.query.project) || {}
        if (project) {
          queryParams.project = project.id
        }
        return queryParams
      },
      typesByGroup() {
        const activeServices = objects._services.filter(object => object.active)
        const sortedServices = activeServices.sort((object1, object2) => object1.order - object2.order)
        return groupBy(sortedServices, 'roleTitle')
      },
    },
    methods: {
      selectType(type) {
        utils.reachGoal(`CREATE_SERVICE_SELECT_${type.typeName.toUpperCase()}`)
        if (type && !type.soon) {
          this.createEntity(type.typeName)
        }
      },
      createEntity(type) {
        this.entity = {
          name: utils.generateName(),
          ...this.queryParams,
          type,
        }
      },
      onSuccess() {
        utils.reachGoal('CREATE_SERVICE_SUCCESS')
        const entityProject = this.projects.find(project => project.id === this.entity.project)
        if (entityProject) {
          entityProject.openPage()
        }
      },
      onFail() {
        utils.reachGoal('CREATE_SERVICE_FAIL')
      },
    },
    mounted() {
      if (this.$route.query.type) {
        this.createEntity(this.$route.query.type)
      }
    },
  }
</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .page > .content { flex: 1; padding: 2em 0 6em!important; }
  .content >>> .segment.secondary { background-color: #efefef!important; }
  .actions { position: fixed; bottom: -5em; left: 0; width: 100%; padding: 1em; border-top: 1px solid #ccc; background-color: #eee!important; z-index: 10; transition: bottom .5s; }
  .actions.selected { bottom: 0; }
  .roles { display: flex; flex-wrap: wrap; justify-content: space-between; }
  .role:nth-child(1), .role:nth-child(2) { margin-bottom: 3em; width: 100%;  }
  .role:nth-child(3) { width: 55%;  }
  .role:nth-child(4) { width: 35%;  }
  .types { align-items: stretch; }
  .type { text-align: center; }
  .type-logo { display: flex; justify-content: center; background-color: #eee; }
  .type-title { padding: .5em 0; font-size: 1.1em; font-weight: bold; }
  .logo { margin: .5em; }
  .back { float: left; text-align: left; }
</style>
